
export default {
  data() {
    return {}
  },
  computed: {
    systemmenue() {
      if (this.$can('Nutzer verwalten') || this.$can('Betriebe verwalten') || this.$can('Treibstofftanks verwalten') || this.$can('Maschinen verwalten')) return true;
      return false;
    },
  },
  methods: {
    logout() {
      this.$auth.logout();
    },
    leaveImpersonate() {
      this.$nuxt.$loading.start();
      this.$axios.put('/api/impersonate/leave').then(() => {
        this.$auth.fetchUser().then(() => {
          this.$router.push('/');
          this.$nuxt.$loading.finish();
        });
      })
    },
  }
}
